<div class="catalogue-import container">
  <section class="import-shell">
    <div class="import-main">
      <p class="eyebrow">Aggiornamento del catalogo</p>
      <h1>Importa catalogo da Excel</h1>
      <p class="lead">
        Carica un file Excel aggiornato per inviarlo al sistema e aggiornare il catalogo.
      </p>

      <div class="upload-zone"
           [class.dragging]="dragging"
           [class.has-file]="selectedFile"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">
        <input #fileInput
               type="file"
               accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
               (change)="onFileSelected($event)"
               hidden>

        <div class="upload-icon" aria-hidden="true">
          <i class="pi pi-file-excel"></i>
        </div>

        @if (selectedFile) {
          <div class="file-summary">
            <strong>{{ selectedFile.name }}</strong>
            <span>{{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB</span>
          </div>
        } @else {
          <div class="file-summary">
            <strong>Trascina qui il file Excel</strong>
            <span>Formati supportati: .xlsx</span>
          </div>
        }

        <button class="link-button" type="button" (click)="fileInput.click()">
          Scegli file
        </button>
      </div>

      <div class="actions">
        <p-button label="Esegui l'importazione"
                  icon="pi pi-upload"
                  [loading]="loading"
                  [disabled]="!canUpload"
                  (click)="upload()"></p-button>

        @if (selectedFile) {
          <p-button label="Rimuovi"
                    icon="pi pi-times"
                    variant="text"
                    severity="secondary"
                    [disabled]="loading"
                    (click)="clearFile()"></p-button>
        }

        <p-button label="Scarica catalogo Excel"
                  class="download-catalogue-button"
                  icon="pi pi-file-excel"
                  variant="outlined"
                  severity="secondary"
                  [loading]="downloadingCatalogue"
                  [disabled]="loading"
                  (click)="downloadCatalogueExcel()"></p-button>
      </div>

      @if (importErrors.length) {
        <section class="import-errors" aria-live="polite" aria-label="Errori importazione catalogo">
          <img class="error-watermark"
               src="assets/layout/images/catalogue-import-errors.png"
               alt=""
               aria-hidden="true">

          <div class="error-heading">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <div>
              <h2>Import non completato</h2>
              <p>{{ importErrors.length }} errori rilevati nel file.</p>
            </div>
          </div>

          <ul>
            @for (error of importErrors; track $index) {
              <li>
                @if (error.row !== undefined || error.column) {
                  <span class="error-meta">
                    @if (error.row !== undefined) {
                      Riga {{ error.row }}
                    }
                    @if (error.column) {
                      Colonna {{ error.column }}
                    }
                  </span>
                }
                <span>{{ error.message }}</span>
              </li>
            }
          </ul>
        </section>
      }

      <div class="notes" aria-label="Note importazione">
        <div>
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          <span>Un solo file per volta, massimo controllo prima dell'invio.</span>
        </div>
        <div>
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <span>Accetta file Excel in formato <strong>.xlsx</strong>.</span>
        </div>
      </div>
    </div>

    <aside class="import-visual" aria-hidden="true">
      <img src="assets/layout/images/catalogue-import-illustration.svg" alt="">
    </aside>
  </section>
</div>
